import { render, staticRenderFns } from "./AamsTravelRegInfo.vue?vue&type=template&id=6585f876&scoped=true&"
import script from "./AamsTravelRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsTravelRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585f876",
  null
  
)

export default component.exports